import { HttpParams } from "@angular/common/http";
import { Base64File } from "./file";

export interface Grant {
    id: string;
    municipalityId: number;
    name: string;
    description: string;
    year: number;
    createdAt: Date;
    createdBy: string;
    modifiedAt: Date;
    modifiedBy:  string;
    validUntil: Date;
    files: Base64File[];
  }


  export class GetGrantsFilter {
    constructor(
        public municipalityId?: string | null,
        public year?: number | null
    ) {}
  
    toQueryParams(): HttpParams {
        let params = new HttpParams();
  
        if (this.municipalityId) params = params.set('municipalityId', this.municipalityId);
        if (this.year) params = params.set('year', this.year);
  
        return params;
    }
  }